import useMediaQuery from "../../../../hooks/useMediaQuery";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { closeIcon, searchIcon } from "../../../../assets/svgs";
import { overflowCheck } from "../../../../utils/checkers";
import useOutsideClick from "../../../../hooks/useOutsideClick";
import styles from "./globalSearch.module.scss";

export const GlobalSearch = () => {
  const navigate = useNavigate();

  const inputRef = useRef(null);
  const searchRef = useRef(null);

  const desktop = useMediaQuery(`( max-width: 1280px )`);
  const mobile = useMediaQuery(`( max-width: 768px )`);
  const mobileFirst = useMediaQuery(`( max-width: 469px )`);

  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  const handleSearch = (e) => {
    e.preventDefault();
    if (query) {
      navigate(`search/?query=${query}`);
      setQuery("");
      setOpen(false);
    }
  };

  useEffect(() => {
    open && inputRef.current?.focus();
  }, [open]);

  overflowCheck(open);
  useOutsideClick(searchRef, open, setOpen);

  return (
    <div className={styles.globalSearch} ref={searchRef}>
      {!open ? (
        <button onClick={() => setOpen(!open)} type="button" aria-label="open">
          {searchIcon.icon}
        </button>
      ) : (
        <button onClick={() => setOpen(!open)} type="button" aria-label="close">
          {closeIcon.icon}
        </button>
      )}

      <div
        className={
          !open
            ? styles.globalSearch_searchboxClose
            : mobileFirst && open
            ? styles.globalSearch_searchboxOpenMobileFirst
            : mobile && open
            ? styles.globalSearch_searchboxOpenMobile
            : styles.globalSearch_searchboxOpen
        }
      >
        <div className={!desktop ? "container" : ""}>
          <div className={styles.globalSearch_block}>
            <h3>{t("global_search")}</h3>
            <form className={styles.globalSearch_form} onSubmit={handleSearch}>
              <input
                type="text"
                aria-label={t("global_query")}
                ref={inputRef}
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
              <button type="submit" aria-label={t("submit_search_form")}>
                {t("global_search")}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
